/**
 * @generated SignedSource<<f0e115dec421e3404aaf8f3962311023>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChangePasswordQuery$variables = Record<PropertyKey, never>;
export type ChangePasswordQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ChangePassword_query">;
};
export type ChangePasswordQuery = {
  response: ChangePasswordQuery$data;
  variables: ChangePasswordQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChangePassword_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ChangePasswordQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45430eb30860d58dc5f981eb89c66231",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordQuery",
    "operationKind": "query",
    "text": "query ChangePasswordQuery {\n  ...ChangePassword_query\n}\n\nfragment ChangePassword_query on Query {\n  company: companyDomainName {\n    ...CompanyLogo_company\n    id\n  }\n}\n\nfragment CompanyLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "168e1113498700ab663b0933d70075e7";

export default node;
